import React, {useState} from 'react';
import {Input, InputGroup} from 'reactstrap';
import {toast} from 'react-toastify';
import {connect} from 'react-redux';
import {login, setProfile} from 'redux/modules/auth/action';
import './style.scss';
import {useHistory} from 'react-router-dom';
import SpinnerButton from 'components/SpinnerButton/SpinnerSubmitButton';


const SignInPage = (props) => {
    let history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);


    const handleSubmit = async(e) => {
        try {
            e.preventDefault()
            setSubmitting(true);
            await props.login(email, password);
            history.push('/organizations');
        } catch(e) {
            setSubmitting(false);
            if(e && e.message) {
                toast.error(e.message);
                throw e.message;
            }
        }
    };

    return (
        <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center w-100"
             style={{marginTop: '-55px'}}>
            <form onSubmit={handleSubmit}>
                <div className="d-flex flex-column authorization-container">
                    <h3 className="align-self-center mb-2" style={{fontWeight: '600', fontFamily: 'Sans-serif'}}>
                        Sign In
                    </h3>
                    <p className="align-self-center mb-2">Administration area</p>
                    <InputGroup className="mb-2">
                        <div className="input-group-prepend">
                            <span style={{width: '40px'}} className="input-group-text" id="basic-addon1">
                                <i className="fas fa-at"/>
                            </span>
                        </div>
                        <Input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </InputGroup>
                    <InputGroup>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span style={{width: '40px'}} className="input-group-text" id="basic-addon1">
                                    <i className="fas fa-unlock-alt"/>
                                </span>
                            </div>
                            <Input
                                type="password"
                                placeholder="Password"
                                onChange={(e) => setPassword(e.target.value)}
                                value={password}
                                className="form-control"
                                aria-describedby="basic-addon1"
                            />
                        </div>
                    </InputGroup>
                    <div className="d-flex flex-column align-self-start w-100">

                        <SpinnerButton
                            onClick={handleSubmit}
                            title="Login"
                            submitting={submitting}
                            block
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default connect(
    null,
    {login, setProfile},
)(SignInPage);
